import * as React from 'react';
import * as S from './styles';
import { ReactComponent as ExIcon } from 'common/images/close-icon.svg';
import RadioButtonIcon from 'common/icons/radioButtonIcon';
import { validateHourFormat, validateOnlyNumbers } from 'features/Dealers/Listings/Data/state/utils';
import { OperationHourFormat } from 'features/Dealers/Listings/OperationHours';
import * as _ from 'lodash';
import { OperationHour } from './state/types';
import PhoneSelect from '../Data/PhoneSelect';
import { PhoneSourceNumber } from '../Data/state/types';

export interface EditOperationHoursProps {
  operationHoursState?: OperationHourFormat[];
  operationHoursGBP?: OperationHourFormat[];
  operationHoursInfo?: OperationHourFormat[];
  operationHoursType?: string
  operationTypesArray: PhoneSourceNumber[]
  setOperationHoursState: Function;
  setOperationTypeState: Function
}

const DaysOfWeek = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']


const EditOperationHours: React.FC<EditOperationHoursProps> = (props) => {
  
  const [operationHours, setOperationHours] = React.useState<OperationHourFormat[]>([])
  const [operationType, setOperationType] = React.useState(props.operationHoursType)

  const onInputChange = (operationHour: OperationHour, e: React.ChangeEvent<HTMLInputElement>, field: string, index?: number) => {
    const value = e.target.value;   
      if (value.length < 6) {
        //Validate time
        if (field === "openTime") {
            operationHour.openTime = value;
        } else if (field === "closeTime") {
            operationHour.closeTime = value;
        }
      }      
      updateStateOperationHour(operationHour, index);
  }


  const cleanOperationHour = (operationHour: OperationHour, index?: number) => {
          operationHour.openTime = "";
          operationHour.closeTime = "";            
      updateStateOperationHour(operationHour, index);
  }


  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>, field: string) => {
    validateHourFormat(e);
  }



  const updateStateOperationHour = (operationHour: OperationHour, index) => {
    if (index !== undefined && props.operationHoursState?.length) {        
      props.setOperationHoursState([
        ...props.operationHoursState.slice(0, index),
        {...operationHour},
        ...props.operationHoursState.slice(index + 1)
      ]);
    } 
  }

  const renderRadioButton = (selected: boolean) => {
    let radioStyles: any = {fillColor: '#FFFFFF00', strokeColor: '#a5a5a5'};
    if (selected) radioStyles = {fillColor: undefined, strokeColor: undefined}
    return <RadioButtonIcon {...radioStyles} />
  }

  const renderInputField = (operationHour: OperationHour, field: string, value: string, placeholder?: string,  index?: number, disabled?: boolean) => {
    return (
      <S.EditSHInput
        type={'time'}
        backgroundColorValue={disabled ? 'rgba(189, 189, 189, 0.2)' : undefined}
        id={`${field}-${index}`}
        value={disabled ? "" : value.toString()}
        placeholder={disabled ? "" : placeholder}
        readOnly={disabled ? true : undefined}
        disabled={disabled}
        onChange={(e) => onInputChange(operationHour, e, field, index)}
        onKeyPress={(e) => handleKeyPress(e, field)}
      />
    )
  }

  const renderOperationHourRow = (operationHour: OperationHour, index?: number) => {
    //const disableHours = specialHour.is24hrs || specialHour.isClosed;
    return (     
    
      <S.EditSHRowContainer key={index}>
                 
          <S.ViewOperationHourLabel>
            {operationHour.openDay}
          </S.ViewOperationHourLabel>
        
        <S.EditSHRowHours>          
          <S.EditSHRowHoursFlex>
           {
           operationType == "Custom" ?
           <> 
            <S.EditSHHoursFields>              
              {renderInputField(operationHour, "openTime", operationHour.openTime, "open", index, false)}
              {renderInputField(operationHour, "closeTime", operationHour.closeTime, "close", index, false)}
            </S.EditSHHoursFields>    
            <S.EditSHActionsContainer>
              {                
                  <S.EditSHActionClose
                    onClick={() => cleanOperationHour(operationHour,index)}
                  >
                    <ExIcon />
                  </S.EditSHActionClose>
              }
            </S.EditSHActionsContainer>
          </>
            :
            <S.ViewOperationHourValue>
              { (operationHour.openTime!="" && operationHour.openTime!=undefined)?`${operationHour.openTime} - ${operationHour.closeTime}`:`Closed`}
              </S.ViewOperationHourValue>
          }
          </S.EditSHRowHoursFlex>
        </S.EditSHRowHours>
      </S.EditSHRowContainer>
    );
  }

  const handleOperationTypeSelected = (type:string)=>{
    setOperationType(type)            
    props.setOperationTypeState(type)
    let newOperationHours : OperationHourFormat[]=[]
    DaysOfWeek.map((day,index)=>{

      let item = props.operationHoursState?.find(f=> f.openDay?.toLocaleLowerCase() == day.toLocaleLowerCase());
      if (type== "GBP")
        item = props.operationHoursGBP?.find(f=> f.openDay?.toLowerCase() == day.toLocaleLowerCase());
      if (type== "CMS")
        item = props.operationHoursInfo?.find(f=> f.openDay?.toLowerCase() == day.toLocaleLowerCase());      
      
      let operationHour: OperationHour= {
        openDay: day,
        openTime: item && item.openTime!= "Closed" && item.openTime!= undefined ? item.openTime: "",
        closeDay:day,
        closeTime:item && item.closeTime!= "Closed" && item.closeTime!= undefined? item.closeTime: "",
      }
      newOperationHours.push(operationHour)
    })    
    setOperationHours(newOperationHours)
    props.setOperationHoursState(newOperationHours)

  }

  const renderOperationHourType = () =>{    
    return (
      <S.EditSHRowContainer>
        <S.EditSHRowDate>
          <S.EditSHRowTitle>
            Select Source:
          </S.EditSHRowTitle>
          <S.EditSHDateFields>
            <PhoneSelect 
              phones={props.operationTypesArray}                                
              selectedPhone={operationType=="GMB"?"GBP":operationType}                                
              displayAll={false}
              onPhoneSelected={(value) => handleOperationTypeSelected(value.source)}

            />
          </S.EditSHDateFields>          
        </S.EditSHRowDate>
      </S.EditSHRowContainer>
    );
  }

  React.useEffect(()=>{
    if (props.operationHoursState)
      handleOperationTypeSelected(props.operationHoursType??"")
  },[])

  
  return (
    <S.EditSpecialHoursContainer>
      { renderOperationHourType() }
      <S.EditSHDividerContainer>
        <S.EditSHDivider />
      </S.EditSHDividerContainer>
      <S.Message>
      Hours are in 24 hour format to simplify selection. Once selected and saved, they'll be displayed in AM/PM format.
      </S.Message>
      <S.EditSHRowsContainer>
        {                    
          (operationHours?.length  && operationHours.length > 0) ?
            operationHours.map((operationHour, index) => {
              return renderOperationHourRow(operationHour, index);
            })
          :
            <></>
        }
      </S.EditSHRowsContainer>
    </S.EditSpecialHoursContainer>
  )
}

export default EditOperationHours